<template>
  <div class="dialogFw">
    <el-dialog
      title="选择范围"
      :visible.sync="openCardDialog"
      custom-class="dialogFw"
    >
      <div class="dialogViewslf lf">
        <!-- <el-input placeholder="请输入内容" v-model="FwSearch" class="searchFw" @change="handsearch"> <i slot="prefix" class="el-input__icon el-icon-search"></i></el-input>  -->
        <el-autocomplete
          class="searchFw"
          v-model="FwSearch"
          placeholder="请输入内容"
          :fetch-suggestions="querySearch"
          :trigger-on-focus="false"
          @change="loadAll"
          @select="handsearch"
          ><i slot="prefix" class="el-input__icon el-icon-search"></i
        ></el-autocomplete>
        <!--  -->
        <div :style="{ 'margin-top': '20px', 'margin-left': '10px' }">
          <el-checkbox :indeterminate="false" @change="handleTableChange"
            >全选</el-checkbox
          >
        </div>
        <!-- table -->
        <template>
          <el-table
            id="departTable"
            ref="departTable"
            :border="true"
            :data="departPeopleList"
            :show-header="false"
            style="width: 100%; margin-bottom: 20px"
            row-key="id"
            :style="{ 'margin-top': '20px' }"
            :tree-props="{ children: 'chil' }"
            @select="handleSelectionChange"
            @row-click="handleRowClick"
          >
            <el-table-column type="selection" width="45"> </el-table-column>

            <el-table-column prop="title" label="部门/学员">
              <template slot-scope="scope">
                <span>{{ scope.row.title }}</span>
                <span v-if="scope.row.mobile">({{ scope.row.mobile }})</span>
              </template>
            </el-table-column>
          </el-table>
        </template>

        <!-- old -->
        <!-- <div class="creadDialog">
                    <span v-for="(item,index) in breadList" :key="index" :data-id="item.id" @click="handMoveBread(item.type,item.id,index)">{{item.name}}
                        <i v-if="breadList.length!=1 && (index+1)!=breadList.length" class="rf"> / </i>
                    </span>
                </div> -->
        <!-- <div class="checkSection lf">
                    <el-checkbox :indeterminate="isIndeteall" v-model="checkAll" @change="handleCheckAllChange">全选</el-checkbox>
                    <el-checkbox-group v-model="SectionCheck" @change="handleCheckedCitiesChange" >
                        <el-checkbox v-for="(item,index) in SectionInp" :label="item" :key="index"  @change="checked=>checkinlist(checked,item)">
                            <span class="lf" v-if="item.sec_name">{{item.sec_name}}</span>
                            <span class="lf" v-else>{{item.nickname}}</span>
                             <el-link :underline="false"  class="checkB rf"  @click.prevent="handchecknext(item.sec_id,item.sec_name,SectionCheck)" v-if="item.sec_id" :disabled="nextClick">下级</el-link>
                             <el-link :underline="false"  class="checkB rf"   v-else="item.sec_id"></el-link>
                             <span class="rf">(2)</span>
                        </el-checkbox>
                    </el-checkbox-group>
                </div> -->
      </div>
      <div
        class="dialogViewsrf lf"
        :style="{ 'max-height': '500px', 'overflow-y': 'scroll' }"
      >
        <el-tag
          effect="plain"
          type="info"
          v-for="(item, index) in SectionList"
          :key="index"
          style="cursor: pointer"
          @click="handleCancel(item)"
        >
          {{ item.title }}
        </el-tag>
      </div>
      <div class="clear"></div>
      <div class="dialogBtn">
        <el-button type="primary" @click="add(bmid)">确定</el-button>
        <el-button @click="selectCancel()">取消</el-button>
      </div>
    </el-dialog>
    <el-dialog
      title="选择监督范围"
      :visible.sync="openSupdDialog"
      custom-class="dialogFw"
    >
      <div class="dialogViewslf lf">
        <el-input placeholder="请输入内容" v-model="FwSearch" class="searchFw"
          ><i slot="prefix" class="el-input__icon el-icon-search"></i
        ></el-input>
        <div class="creadDialog">
          <span
            v-for="(item, index) in supList"
            :key="index"
            :data-id="item.id"
            @click="handsupMoveBread(item.type, item.id, index)"
            >{{ item.name }}
            <i
              v-if="supList.length != 1 && index + 1 != supList.length"
              class="rf"
            >
              /
            </i>
          </span>
        </div>
        <div class="checkSection lf">
          <el-checkbox
            :indeterminate="isIndeterminate"
            v-model="checksupAll"
            @change="handlesupCheckAllChange"
            >全选</el-checkbox
          >
          <el-checkbox-group
            v-model="SectionsupCheck"
            @change="handlesupCheckedCitiesChange"
          >
            <el-checkbox
              v-for="(item, index) in SupSectionInp"
              :label="item"
              :key="index"
            >
              <span class="lf" v-if="item.sec_name">{{ item.sec_name }}</span>
              <span class="lf" v-else>{{ item.nickname }}</span>
              <el-link
                :underline="false"
                class="checkB rf"
                @click.prevent="
                  handsupchecknext(item.sec_id, item.sec_name, SectionsupCheck)
                "
                v-if="item.sec_id"
                :disabled="nextClick"
                >下级</el-link
              >
              <el-link
                :underline="false"
                class="checkB rf"
                v-else="item.sec_id"
              ></el-link>
              <span class="rf">(2)</span>
            </el-checkbox>
          </el-checkbox-group>
        </div>
      </div>
      <div
        class="dialogViewsrf lf"
        :style="{ 'max-height': '500px', 'overflow-y': 'scroll' }"
      >
        <el-tag
          effect="plain"
          type="info"
          v-for="(item, index) in SectionsupList"
          :key="index"
          >{{ item.name }}</el-tag
        >
      </div>
      <div class="clear"></div>
      <div class="dialogBtn">
        <el-button type="primary" @click="add(bmid)">确定</el-button>
        <el-button @click="openSupdDialog = false">取消</el-button>
      </div>
    </el-dialog>
    <el-dialog
      title="选择试卷"
      :visible.sync="openViewDialog"
      custom-class="dialogFw"
    >
      <div class="ViewDialog_search">
        <el-input
          placeholder="请输入内容"
          v-model="FwSearch"
          class="searchFw"
          @change="searchtxt"
          ><i slot="prefix" class="el-input__icon el-icon-search"></i
        ></el-input>
        <el-button
          type="primary"
          icon="el-icon-plus"
          class="FwaddExam"
          @click="hrefnew"
          >新增试卷</el-button
        >
      </div>
      <div class="ViewDialog_ExamWrap">
        <div class="ViewDialog_views lf">
          <el-tree
            :data="data"
            :props="exampProps"
            @node-click="nodeclick"
          ></el-tree>
        </div>
        <div class="ViewDialog_Exams lf">
          <el-radio-group v-model="examViews">
            <el-radio
              :label="item.p_id"
              v-for="(item, index) in examList"
              :key="index"
              :data-id="item.p_name"
              :data-scroe="item.p_scores"
              ref="item"
            >
              <span class="lf">{{ item.p_name }}</span>
              <el-button type="text" class="rf" @click="hrefTo(item.p_id)"
                >预览</el-button
              >
              <span class="rf Exams_time">{{ item.p_time }}</span>
            </el-radio>
          </el-radio-group>
          <page
            :count="count"
            :Page.sync="page"
            :limitrue.sync="limitrue"
            @pagenation="pagetion"
            v-if="limitrue == true"
          ></page>
        </div>
        <div class="clear"></div>
        <div class="ViewDiaolog_Btn">
          <el-button type="primary" @click="Upview">保存</el-button>
          <el-button @click="clearInput()">取消</el-button>
        </div>
      </div>
    </el-dialog>
    <el-dialog
      title="选择试题"
      :visible.sync="openPaperDialog"
      custom-class="dialogFw dialogSt"
    >
      <div class="ViewDialog_search">
        <el-input
          placeholder="请输入内容"
          v-model="FwSearch"
          class="searchFw"
          @change="searchexam"
          ><i slot="prefix" class="el-input__icon el-icon-search"></i
        ></el-input>
        <span class="rf"
          >已选择<em style="color: red">{{ checknum }}</em
          >题</span
        >
      </div>
      <div class="ViewDialog_ExamWrap">
        <div class="ViewDialog_views lf">
          <el-tree
            :data="paper"
            :props="defaultProps"
            @node-click="examtree"
          ></el-tree>
        </div>
        <div class="ViewDialog_Exams lf">
          <el-checkbox
            :indeterminate="isIndeterminate"
            v-model="stchakall"
            @change="stchakallchange"
            >全选</el-checkbox
          >
          <el-checkbox-group v-model="examRadio" @change="checkstlist">
            <el-checkbox
              :label="item.q_id"
              v-for="(item, index) in treeExam"
              :key="index"
              :data-id="item.q_id"
              ref="examtree"
            >
              <span class="lf">{{ item.questions }}</span>
            </el-checkbox>
          </el-checkbox-group>
          <page
            :count="count"
            :curpage.sync="page"
            :limitrue.sync="limitrue"
            @pagenation="pagetree"
            v-if="limitrue == true"
          ></page>
        </div>
        <div class="clear"></div>
        <div class="ViewDiaolog_Btn">
          <el-button type="primary" @click="Uptree">保存</el-button>
          <el-button @click="openPaperDialog = false">取消</el-button>
        </div>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import page from "./page";
import dialogRecursMixins from "@/assets/js/dialogRecursMixins.js";
export default {
  name: "dialogFw",
  mixins: [dialogRecursMixins],
  data() {
    return {
      suggestList: [],
      departPeopleList: [],
      url: this.HOME,
      FwSearch: "",
      checkAll: false,
      breadList: [{ name: "泉州劲氏软件科技有限公司", id: "1", type: "1" }],
      checksupAll: false,
      supList: [{ name: "泉州劲氏软件科技有限公司", id: "1", type: "1" }],
      SectionsupList: [],
      SectionsupCheck: [],
      isIndeterminate: false,
      limitrue: false,
      isIndeteall: false,
      SectionCheck: [],
      SectionInp: [],
      SupSectionInp: [],
      PeoList: [],
      paper: [],
      examSetList: [],
      nextClick: false,
      listPage: 0,
      data: [],
      limit: 6, //一页几条数据
      count: 0, //数据总计
      page: 1, //当前页数
      SectionList: [],
      examList: [],
      checknum: 0,
      cid: "",
      pid: "",
      dataId: "",
      stchakall: false,
      examViews: "",
      examRadio: [],
      status: false,
      checkin: [],
      treeExam: "",
      exampProps: {
        children: "son",
        label: "name",
      },
      defaultProps: {
        children: "son",
        label: "model_name",
      },
    };
  },
  props: {
    visible: {
      default: false,
      type: Boolean,
    },
    tableData: {
      default: () => [],
      type: Array,
    },
    supshow: {
      default: false,
      type: Boolean,
    },
    addViewExam: {
      default: false,
      type: Boolean,
    },
    addViewPaper: {
      default: false,
      type: Boolean,
    },
    addCourseware: {
      default: false,
      type: Boolean,
    },
    bmid: {
      default: 0,
      type: Number,
    },
  },
  methods: {
    selectCancel() {
      this.openCardDialog = false;
    },
    clearInput() {
      this.FwSearch = "";
      this.searchtxt();
      this.openViewDialog = false;
    },
    // 搜索框建议数据
    async loadAll() {
      var list = [];
      var data = {
        service: "Mytask.Test",
        nickname: this.FwSearch,
      };
      let res = await this.$axios.post(this.HOME, this.$qs.stringify(data));
      if (res.data.data.code !== 200) {
        return [];
      }
      list = res.data.data.info;
      list = list.map((item) => {
        item.value = item.nickname + "(" + item.mobile + ")";
        return item;
      });
      return list;
    },
    // 渲染搜索框建议数据
    async querySearch(queryString, callback) {
      var restaurants = await this.loadAll();
      var results = queryString
        ? restaurants.filter(this.createFilter(queryString))
        : restaurants;
      callback(results);
    },
    createFilter(queryString) {
      return (restaurant) => {
        return (
          restaurant.value.toLowerCase().indexOf(queryString.toLowerCase()) ===
          0
        );
      };
    },
    // 搜索框搜索
    handsearch(item) {
      for (let i in this.SectionList) {
        if (this.SectionList[i].id == item.user_id) {
          return this.alertView.failView("该人员已经被选择");
        }
      }

      if (item.junchen != 2) {
        return this.alertView.failView("该用户暂未进行分部归类");
      }

      let newData = {};
      newData.id = item.user_id;
      newData.title = item.nickname;
      newData.checked = true;
      let pid = this.recursFindAll(newData.id);
      for (let i in pid) {
        this.recursStatus(pid[i], false);
      }
      this.recursStatus(newData.id, false);
      this.deletePeople(newData.id, newData);
      this.FwSearch = "";
    },
    // 获取部门人员列表
    getDepartPeopleList() {
      let params = {};
      params.service = "Examtask.Departusers";
      this.$axios.post(this.HOME, this.$qs.stringify(params)).then((res) => {
        let newData = res.data.data;
        this.departPeopleList = this.recursData(newData);
      });
    },
    // 全选
    handleTableChange(val) {
      this.recursCheck(val);
    },
    // 选择
    handleSelectionChange(val, row) {
      console.log(val, row.checked);
      // 下级渲染
      let lowerId = this.recursFindNextAllId(row.id);
      for (let i in lowerId) {
        this.recursStatus(lowerId[i], row.checked);
      }
      // 上级渲染
      if (!row.checked) {
        let uperId = this.recursFindAllId(row.id);
        for (let i in uperId) {
          this.recursStatus(uperId[i], row.checked);
        }
      }
      // 当对人员进行勾选后，再点击取消时，商户列表也要跟着取消
      if (row.checked) {
        this.recursLastCheck(row.id);
      }
      this.recursStatus(row.id, row.checked, true);
      this.adjustPeople(row);
    },
    // 判断是否是学员
    adjustPeople(data) {
      let str1 = "d";
      let str2 = "m";
      let lowerId = this.recursFindNextAllId(data.id);
      let people = data.id.search(str1) == -1 && data.id.search(str2) == -1;
      if (people) {
        this.deletePeople(data.id, data);
      } else {
        let newId = [];
        for (let i in lowerId) {
          if (lowerId[i].search(str1) == -1 && lowerId[i].search(str2) == -1) {
            newId.push(lowerId[i]);
          }
        }
        for (let i in newId) {
          this.deletePeople(newId[i], this.recursFindUser(newId[i]));
        }
      }
    },
    // 点击某一行切换展开状态
    handleRowClick(row, col, event) {
      this.$refs.departTable.toggleRowExpansion(row);
    },
    // 点击取消人员选择
    handleCancel(row) {
      console.log(row);
      let upId = this.recursFindAllId(row.id);
      if (!row.checked) {
        for (let i in upId) {
          this.recursStatus(upId[i], true);
        }
      }
      this.recursLastCheck(row.id);
      this.recursStatus(row.id, true);

      row.checked = false;
      this.deletePeople(row.id, row);
    },

    handleCheckAllChange(val) {
      var model = [];
      var model_list = [];
      var modelArr = this.SectionList;

      //临时数组存放
      var tempArray1 = []; //临时数组1
      var tempArray2 = []; //临时数组2

      if (val) {
        for (let i = 0; i < this.SectionInp.length; i++) {
          if (this.SectionInp[i].sec_name) {
            model.push({
              name: this.SectionInp[i].sec_name,
              key: this.SectionInp[i].sec_id,
              type: "1",
            });
          } else {
            model.push({
              name: this.SectionInp[i].nickname,
              key: this.SectionInp[i].user_id,
              type: "2",
            });
          }
          model_list.push(this.SectionInp[i]);
        }
        for (var i = 0; i < this.SectionList.length; i++) {
          tempArray1[this.SectionList[i].key] = true; //将数array2 中的元素值作为tempArray1 中的键，值为true；
        }
        for (var i = 0; i < model.length; i++) {
          if (!tempArray1[model[i].key]) {
            tempArray2.push(model[i]); //过滤array1 中与array2 相同的元素；
          }
        }
        for (let n in tempArray2) {
          modelArr.push(tempArray2[n]);
        }
      } else {
        for (let i = 0; i < this.SectionInp.length; i++) {
          if (this.SectionInp[i].sec_name) {
            model.push({
              name: this.SectionInp[i].sec_name,
              key: this.SectionInp[i].sec_id,
              type: "1",
            });
          } else {
            model.push({
              name: this.SectionInp[i].nickname,
              key: this.SectionInp[i].user_id,
              type: "2",
            });
          }
          model_list = [];
        }
        for (var i = 0; i < this.SectionList.length; i++) {
          tempArray1[this.SectionList[i].key] = true; //将数array2 中的元素值作为tempArray1 中的键，值为true；
        }
        for (var i = 0; i < model.length; i++) {
          if (tempArray1[model[i].key]) {
            tempArray2.push(model[i]); //过滤array1 中与array2 相同的元素；
          }
        }
        let add = modelArr.filter(
          (item) => !tempArray2.some((ele) => ele.key === item.key)
        );
        modelArr = add;
      }
      this.SectionCheck = model_list;
      this.SectionList = modelArr;
      this.isIndeterminate = false;
    },
    checkinlist(status, value) {
      this.checkin = [];
      this.status = status;
      this.checkin.push(value);
    },
    handleCheckedCitiesChange(value) {
      var List = [];

      if (this.SectionList.length > 0) {
        localStorage.setItem("ylist", JSON.stringify(this.SectionList));
      } else {
        localStorage.setItem("ylist", JSON.stringify([]));
      }
      for (let i in value) {
        if (value[i].sec_id) {
          List.push({
            key: value[i].sec_id,
            name: value[i].sec_name,
            type: "1",
          });
        } else {
          List.push({
            key: value[i].user_id,
            name: value[i].nickname,
            type: "2",
          });
        }
      }
      var arrlist = JSON.parse(localStorage.getItem("ylist"));
      var arrin = this.checkin[0];
      if (this.status == false) {
        arrlist = arrlist.filter(function (item) {
          if (arrin.sec_id) {
            if (item.key != arrin.sec_id) {
              return item;
            }
          } else {
            if (item.key != arrin.user_id) {
              return item;
            }
          }
        });
        this.SectionList = arrlist;
        return false;
      }
      var arr = [];

      if (arrlist.length == 0) {
        for (var j = 0; j < List.length; j++) {
          arr.push(List[j]);
        }
      } else {
        for (var i = 0; i < arrlist.length; i++) {
          for (var j = 0; j < List.length; j++) {
            if (List[j].key != arrlist[i].key) {
              arr = arrlist.concat(List[j]);
            }
          }
        }
      }
      this.SectionList = arr;
      let checkedCount = value.length;
      this.checkAll = checkedCount === this.SectionInp.length;
      this.isIndeterminate =
        checkedCount > 0 && checkedCount < this.SectionInp.length;
    },
    handchecknext(id, name, checkname) {
      for (let a in checkname) {
        if (name == checkname[a].sec_name) {
          this.nextclick = true;
          this.alertView.failView("打钩的选项不能点选下级");
          return true;
        } else {
          this.nextclick = false;
        }
      }
      var data = { service: "Examtask.Adminson", id: id };
      var list = [];
      this.$axios.post(this.HOME, this.$qs.stringify(data)).then((res) => {
        {
          if (res.data.data.code) {
            this.alertView.failView("暂无下级分类");
            return false;
          } else {
            for (let i = 0; i < res.data.data.length; i++) {
              list.push(res.data.data[i]);
            }
            this.SectionInp = list;
            this.breadList.push({ name: name, id: id, type: "2" });
          }
        }
        var arr = [];
        for (var i = 0; i < this.SectionList.length; i++) {
          for (var j = 0; j < this.SectionInp.length; j++) {
            if (this.SectionInp[j].user_id) {
              if (this.SectionInp[j].user_id == this.SectionList[i].key) {
                arr.push(this.SectionInp[j]);
              }
            } else {
              console.log(this.SectionInp);
              if (this.SectionInp[j].sec_id == this.SectionList[i].key) {
                arr.push(this.SectionInp[j]);
              }
            }
          }
        }
        //  else {
        //         for(var i=0; i<this.SectionInp.length; i++) {
        //             for(var j=0; j<this.SectionList.length; j++) {
        //                 if(this.SectionList[j].key == this.SectionInp[i].user_id) {
        //                     arr.push(this.SectionList[j]);
        //                 }
        //             }
        //     }
        // }
        console.log(arr);
        this.SectionCheck = arr;
      });
    },
    stchakallchange(value) {
      let up = [];
      $.each(this.treeExam, function (i, ix) {
        up.push(ix.q_id);
      });
      this.examRadio = value ? up : [];
      this.checknum = value ? this.treeExam.length : 0;
      this.isIndeteall = false;
    },
    handMoveBread(type, id, index) {
      //临时数组存放
      var tempArray1 = []; //临时数组1
      var tempArray2 = []; //临时数组2
      this.SectionInp = [];
      if (type == 1) {
        this.breadList = [
          { name: "泉州劲氏软件科技有限公司", id: "1", type: "1" },
        ];
        var data = { service: "Examtask.Admininfo" };
        this.$axios.post(this.HOME, this.$qs.stringify(data)).then((res) => {
          for (let i = 0; i < res.data.data.length; i++) {
            this.SectionInp.push(res.data.data[i]);
          }
          for (var i = 0; i < this.SectionList.length; i++) {
            tempArray1[this.SectionList[i].key] = true; //将数array2 中的元素值作为tempArray1 中的键，值为true；
          }
          for (var a = 0; a < this.SectionInp.length; a++) {
            if (tempArray1[this.SectionInp[a].sec_id]) {
              tempArray2.push(this.SectionInp[a]); //过滤array1 中与array2 相同的元素；
            }
          }
          this.SectionCheck = tempArray2;
        });
      } else {
        this.SectionInp = [];
        var data = { service: "Examtask.Adminson", id: id };
        var list = [];
        var bList = this.breadList;
        var len = this.breadList.length;
        var newlist = bList.splice(index + 1, len - (index + 1));
        this.listPage = bList.length - 1;
        this.$axios.post(this.HOME, this.$qs.stringify(data)).then((res) => {
          {
            if (res.data.data.code) {
              this.alertView.failView("暂无下级分类");
            } else {
              for (let i = 0; i < res.data.data.length; i++) {
                this.SectionInp.push(res.data.data[i]);
              }
              for (var i = 0; i < this.SectionList.length; i++) {
                tempArray1[this.SectionList[i].key] = true; //将数array2 中的元素值作为tempArray1 中的键，值为true；
              }
              for (var a = 0; a < this.SectionInp.length; a++) {
                if (tempArray1[this.SectionInp[a].sec_id]) {
                  if (tempArray1[this.SectionInp[a].sec_id]) {
                    tempArray2.push(this.SectionInp[a]); //过滤array1 中与array2 相同的元素；
                  }
                } else {
                  if (tempArray1[this.SectionInp[a].user_id]) {
                    tempArray2.push(this.SectionInp[a]); //过滤array1 中与array2 相同的元素；
                  }
                }
              }
              this.SectionCheck = tempArray2;
            }
          }
        });
      }
    },
    handsupMoveBread(type, id, index) {
      //临时数组存放
      var tempArray1 = []; //临时数组1
      var tempArray2 = []; //临时数组2
      this.SectionInp = [];
      if (type == 1) {
        this.breadList = [
          { name: "泉州劲氏软件科技有限公司", id: "1", type: "1" },
        ];
        var data = { service: "Examtask.Admininfo" };
        this.$axios.post(this.HOME, this.$qs.stringify(data)).then((res) => {
          for (let i = 0; i < res.data.data.length; i++) {
            this.SectionInp.push(res.data.data[i]);
          }
          console.log(this.SectionInp);
          for (var i = 0; i < this.SectionList.length; i++) {
            tempArray1[this.SectionList[i].key] = true; //将数array2 中的元素值作为tempArray1 中的键，值为true；
          }
          for (var a = 0; a < this.SectionInp.length; a++) {
            if (tempArray1[this.SectionInp[a].sec_id]) {
              tempArray2.push(this.SectionInp[a]); //过滤array1 中与array2 相同的元素；
            }
          }
          this.SectionCheck = tempArray2;
        });
      } else {
        this.SectionInp = [];
        var data = { service: "Examtask.Adminson", id: id };
        var list = [];
        var bList = this.breadList;
        var len = this.breadList.length;
        var newlist = bList.splice(index + 1, len - (index + 1));
        this.listPage = bList.length - 1;
        this.$axios.post(this.HOME, this.$qs.stringify(data)).then((res) => {
          {
            if (res.data.data.code) {
              this.alertView.failView("暂无下级分类");
            } else {
              for (let i = 0; i < res.data.data.length; i++) {
                this.SectionInp.push(res.data.data[i]);
              }
              console.log(this.SectionInp);
              for (var i = 0; i < this.SectionList.length; i++) {
                tempArray1[this.SectionList[i].key] = true; //将数array2 中的元素值作为tempArray1 中的键，值为true；
              }
              for (var a = 0; a < this.SectionInp.length; a++) {
                if (tempArray1[this.SectionInp[a].user_id]) {
                  tempArray2.push(this.SectionInp[a]); //过滤array1 中与array2 相同的元素；
                }
              }
              this.SectionCheck = tempArray2;
            }
          }
        });
      }
    },

    nodeclick(node, data, vuecomponent) {
      let reslen = data.childNodes.length;
      this.cid = data.data.c_id;
      var data = {
        service: "Exampaper.Paperbycate",
        limit: 6,
        page: 1,
        c_id: data.data.c_id,
      };
      var list = [];
      this.page = 1;
      this.$axios.post(this.HOME, this.$qs.stringify(data)).then((res) => {
        if (res.data.data.code == 0) {
          this.limitrue = true;
          this.count = parseInt(res.data.data.info.count);
          for (var i = 0; i < res.data.data.info.list.length; i++) {
            list.push(res.data.data.info.list[i]);
          }
          this.examList = list;
          this.limitrue = false;
          this.$nextTick(() => {
            //重新渲染分页
            this.limitrue = true;
          });
        } else {
          if (reslen > 0) {
          } else {
            this.alertView.failView(res.data.data.msg);
          }
        }
      });
    },
    searchexam() {
      var that = this;
      var list = [];
      let dataup = {
        service: "Examination.Examall",
        where: this.FwSearch,
        page: 1,
        limit: 1000,
      };
      this.$axios
        .post(this.HOME, this.$qs.stringify(dataup))
        .then((res) => {
          for (var i = 0; i < res.data.data.info.length; i++) {
            list.push(res.data.data.info[i]);
          }
          this.paper = list;
        })
        .catch(function (error) {
          // 请求失败处理
          console.log(error);
        });
    },
    searchtxt() {
      var that = this;
      this.comview.search(
        this.HOME,
        {
          service: "Cate.Cateinfo",
          cate_name: this.FwSearch,
          userid: localStorage.getItem("userid"),
        },
        function (res, Message) {
          var list = [];
          for (var i = 0; i < res.data.data.length; i++) {
            list.push(res.data.data[i]);
          }
          that.data = list;
        }
      );
    },
    pagetion(limit, page) {
      console.log(page);
      var data = {
        service: "Exampaper.Paperbycate",
        limit: 6,
        page: page,
        c_id: this.cid,
      };
      var List = [];
      var url = this.url;
      this.$axios
        .post(url, this.$qs.stringify(data))
        .then((res) => {
          for (let i = 0; i < res.data.data.info.list.length; i++) {
            List.push(res.data.data.info.list[i]);
          }
          this.examList = List;
        })
        .catch(function (error) {
          // 请求失败处理
          console.log(error);
        });
    },
    pagetree(limit, page) {
      var data = {
        service: "Examination.ExamInfo",
        limit: 6,
        page: page,
        id: this.pid,
        userid: localStorage.getItem("userid"),
      };
      var list = [];
      var url = this.url;
      this.$axios
        .post(url, this.$qs.stringify(data))
        .then((res) => {
          this.count = parseInt(res.data.data.count);
          for (var i = 0; i < res.data.data.info.length; i++) {
            list.push(res.data.data.info[i]);
          }
          this.treeExam = list;
        })
        .catch(function (error) {
          // 请求失败处理
          console.log(error);
        });
    },
    Upview() {
      var score = "";
      var pass = "";
      if (this.examViews == "") {
        this.alertView.failView("还没有选择试题");
        return false;
      }
      for (let i in this.examList) {
        if (this.examList[i].p_id == this.examViews) {
          console.log(this.examList[i]);
          this.dataId = this.examList[i].p_name;
          score = this.examList[i].p_scores;
          pass = this.examList[i].p_pass;
        } else {
        }
      }
      this.$emit("examViews", this.dataId, this.examViews, score, pass);
      this.openViewDialog = false;
    },
    Uptree() {
      if (this.examRadio == "") {
        this.alertView.failView("还没选择试题");
        return false;
      }
      var id = this.examRadio;
      var list = [];
      var data = {
        service: "Exampaper.GetQsninfo",
        qid: JSON.stringify(id),
      };
      this.$axios.post(this.HOME, this.$qs.stringify(data)).then((res) => {
        for (let i in res.data.data) {
          this.tableData.push(res.data.data[i]);
        }
      });
      this.examSetList = this.tableData;
      this.$emit("addView", this.examSetList);
      this.openPaperDialog = false;
      this.examRadio = [];
    },
    hrefTo(id) {
      let hto = this.$router.resolve({ path: "/examView/", query: { id: id } });
      window.open(hto.href, "_blank");
    },
    hrefnew() {
      this.$router.push({ path: "/addpaper/" });
    },
    examtree(e) {
      var id = e.e_id;
      this.pid = id;
      var list = [];
      var data = {
        service: "Examination.ExamInfo",
        id: id,
        limit: this.limit,
        userid: localStorage.getItem("userid"),
      };
      this.$axios.post(this.HOME, this.$qs.stringify(data)).then((res) => {
        this.limitrue = true;
        if (res.data.data.code === 0) {
          this.count = parseInt(res.data.data.count);
          for (var i = 0; i < res.data.data.info.length; i++) {
            list.push(res.data.data.info[i]);
          }
        } else {
          this.alertView.failView("该分类没有试题");
        }
      });
      this.treeExam = list;
    },
    add(id) {
      this.openCardDialog = false;
      if (id == 1 || id == 2) {
        this.$emit("bmidfw", id, this.SectionList);
      }
      // else if(id==2){
      //     var data = []
      //     for (let n in this.SectionList){
      //         data.push({id:this.SectionList[n].key,name:this.SectionList[n].name})
      //     }
      //     this.$emit('bmidfw',id,data)
      // }
      else if (id == 3) {
        var data = [];
        for (let n in this.SectionList) {
          data.push({ id: this.SectionList[n].key });
        }
        this.$emit("bmidfw", id, data);
      }
    },
    checkstlist(val) {
      this.checknum = val.length + this.tableData.length;
    },
    handlesupCheckAllChange(val) {
      var model = [];
      var model_list = [];
      var modelArr = this.SectionsupList;

      //临时数组存放
      var tempArray1 = []; //临时数组1
      var tempArray2 = []; //临时数组2

      if (val) {
        for (let i = 0; i < this.SupSectionInp.length; i++) {
          if (this.SupSectionInp[i].sec_name) {
            model.push({
              name: this.SupSectionInp[i].sec_name,
              key: this.SupSectionInp[i].sec_id,
              type: "1",
            });
          } else {
            model.push({
              name: this.SupSectionInp[i].nickname,
              key: this.SupSectionInp[i].user_id,
              type: "2",
            });
          }
          model_list.push(this.SupSectionInp[i]);
        }
        for (var i = 0; i < this.SectionsupList.length; i++) {
          tempArray1[this.SectionsupList[i].key] = true; //将数array2 中的元素值作为tempArray1 中的键，值为true；
        }
        for (var i = 0; i < model.length; i++) {
          if (!tempArray1[model[i].key]) {
            tempArray2.push(model[i]); //过滤array1 中与array2 相同的元素；
          }
        }
        for (let n in tempArray2) {
          modelArr.push(tempArray2[n]);
        }
      } else {
        for (let i = 0; i < this.SupSectionInp.length; i++) {
          if (this.SupSectionInp[i].sec_name) {
            model.push({
              name: this.SupSectionInp[i].sec_name,
              key: this.SupSectionInp[i].sec_id,
              type: "1",
            });
          } else {
            model.push({
              name: this.SupSectionInp[i].nickname,
              key: this.SupSectionInp[i].user_id,
              type: "2",
            });
          }
          model_list = [];
        }
        for (var i = 0; i < this.SectionsupList.length; i++) {
          tempArray1[this.SectionsupList[i].key] = true; //将数array2 中的元素值作为tempArray1 中的键，值为true；
        }
        for (var i = 0; i < model.length; i++) {
          if (tempArray1[model[i].key]) {
            tempArray2.push(model[i]); //过滤array1 中与array2 相同的元素；
          }
        }
        let add = modelArr.filter(
          (item) => !tempArray2.some((ele) => ele.key === item.key)
        );
        modelArr = add;
      }
      this.SectionsupCheck = model_list;
      this.SectionsupList = modelArr;
      this.isIndeterminate = false;
    },
    handlesupCheckedCitiesChange(value) {
      var List = [];
      for (let i in value) {
        if (value[i].sec_id) {
          List.push({
            key: value[i].sec_id,
            name: value[i].sec_name,
            type: "1",
          });
        } else {
          List.push({
            key: value[i].user_id,
            name: value[i].nickname,
            type: "2",
          });
        }
      }
      this.SectionsupList = List;
      let checkedCount = value.length;
      this.checksupAll = checkedCount === this.SupSectionInp.length;
      this.isIndeterminate =
        checkedCount > 0 && checkedCount < this.SupSectionInp.length;
    },
    handsupchecknext(id, name, checkname) {
      for (let a in checkname) {
        if (name == checkname[a].sec_name) {
          this.nextclick = true;
          this.alertView.failView("打钩的选项不能点选下级");
          return true;
        } else {
          this.nextclick = false;
        }
      }
      var data = { service: "Examtask.Adminson", id: id };
      var list = [];
      this.$axios.post(this.HOME, this.$qs.stringify(data)).then((res) => {
        {
          if (res.data.data.code) {
            this.alertView.failView("暂无下级分类");
          } else {
            for (let i = 0; i < res.data.data.length; i++) {
              list.push(res.data.data[i]);
            }
            this.SupSectionInp = list;
            this.supList.push({ name: name, id: id, type: "2" });
          }
        }
      });
    },
    // handsupMoveBread(type,id,index){
    //     //临时数组存放
    //     var tempArray1 = [];//临时数组1
    //     var tempArray2 = [];//临时数组2
    //     this.SupSectionInp = []
    //     if(type==1){
    //         this.supList=[{name:'泉州劲氏软件科技有限公司',id:'1',type:'1'}]
    //         var data ={service:'Examtask.Admininfo'}
    //             this.$axios.post(this.HOME,this.$qs.stringify(data))
    //             .then(res=>{
    //                 for(let i=0 ;i <res.data.data.length;i++){
    //                     this.SupSectionInp.push(res.data.data[i])
    //                 }
    //                 for(var i=0;i<this.SectionsupList.length;i++){
    //                     tempArray1[this.SectionsupList[i].key]=true;//将数array2 中的元素值作为tempArray1 中的键，值为true；
    //                 }
    //                 for(var a=0;a<this.SupSectionInp.length;a++){
    //                     if(tempArray1[this.SupSectionInp[a].sec_id]){
    //                         tempArray2.push(this.SupSectionInp[a]);//过滤array1 中与array2 相同的元素；
    //                     }
    //                 }
    //              this.SectionsupCheck = tempArray2
    //              console.log(this.SectionsupCheck)
    //         })
    //     }
    //     else{
    //         this.SupSectionInp=[]
    //         var data ={service:'Examtask.Adminson',id:id}
    //         var list=[]
    //         var bList =this.supList
    //         var len = this.supList.length
    //         var newlist = bList.splice(index+1,len-(index+1))
    //         this.listPage=bList.length-1
    //         this.$axios.post(this.HOME,this.$qs.stringify(data))
    //         .then(res=>{
    //             {
    //                 if(res.data.data.code){
    //                     this.alertView.failView('暂无下级分类')
    //                 }
    //                 else{
    //                     for(let i=0 ;i <res.data.data.length;i++){
    //                         this.SupSectionInp.push(res.data.data[i])
    //                     }
    //                     console.log(this.SupSectionInp)
    //                     for(var i=0;i<this.SectionsupList.length;i++){
    //                         tempArray1[this.SectionsupList[i].key]=true;//将数array2 中的元素值作为tempArray1 中的键，值为true；
    //                     }
    //                     for(var a=0;a<this.SupSectionInp.length;a++){
    //                         if(tempArray1[this.SupSectionInp[a].sec_id]){
    //                             tempArray2.push(this.SupSectionInp[a]);//过滤array1 中与array2 相同的元素；
    //                         }
    //                     }
    //                     this.SectionsupCheck = tempArray2
    //                 }
    //             }
    //         })
    //     }
    // },
    //  handsupMoveBread(type,id,index){
    //     //临时数组存放
    //     var tempArray1 = [];//临时数组1
    //     var tempArray2 = [];//临时数组2
    //     this.SupSectionInp = []
    //     if(type==1){
    //         this.supList=[{name:'泉州劲氏软件科技有限公司',id:'1',type:'1'}]
    //         var data ={service:'Examtask.Admininfo'}
    //             this.$axios.post(this.HOME,this.$qs.stringify(data))
    //             .then(res=>{
    //                 for(let i=0 ;i <res.data.data.length;i++){
    //                     this.SupSectionInp.push(res.data.data[i])
    //                 }
    //                 console.log(this.SupSectionInp)
    //                 for(var i=0;i<this.SectionsupList.length;i++){
    //                     tempArray1[this.SectionsupList[i].key]=true;//将数array2 中的元素值作为tempArray1 中的键，值为true；
    //                 }
    //                 for(var a=0;a<this.SupSectionInp.length;a++){
    //                     if(tempArray1[this.SupSectionInp[a].sec_id]){
    //                         tempArray2.push(this.SupSectionInp[a]);//过滤array1 中与array2 相同的元素；
    //                     }
    //                 }
    //              this.SectionsupCheck = tempArray2
    //              console.log(this.SectionsupCheck)
    //         })
    //     }
    //     else{
    //         this.SupSectionInp=[]
    //         var data ={service:'Examtask.Adminson',id:id}
    //         var list=[]
    //         var bList =this.supList
    //         var len = this.supList.length
    //         var newlist = bList.splice(index+1,len-(index+1))
    //         this.listPage=bList.length-1
    //         this.$axios.post(this.HOME,this.$qs.stringify(data))
    //         .then(res=>{
    //             {
    //                 if(res.data.data.code){
    //                     this.alertView.failView('暂无下级分类')
    //                 }
    //                 else{
    //                     for(let i=0 ;i <res.data.data.length;i++){
    //                         this.SupSectionInp.push(res.data.data[i])
    //                     }
    //                     console.log(this.SupSectionInp)
    //                     for(var i=0;i<this.SectionsupList.length;i++){
    //                         tempArray1[this.SectionsupList[i].key]=true;//将数array2 中的元素值作为tempArray1 中的键，值为true；
    //                     }
    //                     for(var a=0;a<this.SupSectionInp.length;a++){
    //                         if(tempArray1[this.SupSectionInp[a].sec_id]){
    //                             tempArray2.push(this.SupSectionInp[a]);//过滤array1 中与array2 相同的元素；
    //                         }
    //                     }
    //                     this.SectionsupCheck = tempArray2
    //                 }
    //             }
    //         })
    //     }
    // },
  },
  components: {
    page,
  },

  computed: {
    openCardDialog: {
      get() {
        return this.visible;
      },
      set(val) {
        this.$emit("update:visible", val); // openCardDialog改变的时候通知父组件
      },
    },
    openSupdDialog: {
      get() {
        return this.supshow;
      },
      set(val) {
        this.$emit("update:supshow", val); // openCardDialog改变的时候通知父组件
      },
    },
    openViewDialog: {
      get() {
        return this.addViewExam;
      },
      set(val) {
        this.$emit("update:addViewExam", val); // openCardDialog改变的时候通知父组件
      },
    },
    openPaperDialog: {
      get() {
        return this.addViewPaper;
      },
      set(val) {
        this.$emit("update:addViewPaper", val); // openCardDialog改变的时候通知父组件
      },
    },
    openCourseware: {
      get() {
        return this.addCourseware;
      },
      set(val) {
        this.$emit("update:addCourseware", val); // openCardDialog改变的时候通知父组件
      },
    },
  },
  mounted() {
    console.log(this.tableData);
    this.comview.Section(this.HOME, this.SectionInp);
    this.comview.Section(this.HOME, this.SupSectionInp);
    var data = [];
    var list = [];
    this.getDepartPeopleList();
    this.$axios
      .post(
        this.HOME,
        this.$qs.stringify({
          service: "Cate.Cateinfo",
          userid: localStorage.getItem("userid"),
        })
      )
      .then((res) => {
        for (var i = 0; i < res.data.data.length; i++) {
          data.push(res.data.data[i]);
        }
        this.data = data;
      });
    this.$axios
      .post(
        this.HOME,
        this.$qs.stringify({
          service: "Examination.Examall",
          page: 1,
          limit: 1000,
        })
      )
      .then((res) => {
        for (var i = 0; i < res.data.data.info.length; i++) {
          list.push(res.data.data.info[i]);
        }
        this.paper = list;
      });
  },
};
</script>
<style lang="scss" scoped>
div ::v-deep .el-table thead {
  display: none;
}
div ::v-deep .el-table tr {
  height: 50px;
}
div ::v-deep .el-table th.is-leaf:first-child {
  padding: 0;
  margin: 0;
}
div >>> .el-table thead {
  display: none;
}
div >>> .el-table tr {
  height: 50px;
}
div >>> .el-table th.is-leaf:first-child {
  padding: 0;
  margin: 0;
}
div .el-table thead {
  display: none !important;
}
div .el-table tr {
  height: 50px !important;
}
div .el-table th.is-leaf:first-child {
  padding: 0 !important;
  margin: 0 !important;
}
</style>



// WEBPACK FOOTER //
// src/components/Common/dialog.vue